<template>
<div class="npHeader">
    <div class="bgc box-shadow title">
        <div class="classes blod">{{title}}</div>
        <div>
            <span>活动名称&nbsp;&nbsp;</span>
            <el-select v-model="param.eventinnerid" placeholder="请输入关键词选择" filterable remote :disabled="flag"
                       reserve-keyword :remote-method="remoteMethod" :loading="loading" @change="handleSearch">
                <el-option v-for="(item,index) in activityList" :key="index" :label="item.title" :value="item.innerid">{{item.title}}</el-option>
            </el-select>
        </div>
    </div>
</div>
</template>

<script>
import {getSimpleDisEventPageList} from 'api/nationalDistribution'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'npHeader',
    data() {
        return {
            scrollTop: 0,
            activityList: [],
            selectPage: {
                page: 1,
                pageSize: 10,
                pageCount: 1
            },
            loading: false
        }
    },
    props: ['param', 'flag', 'title'],
    mounted() {
        this._getDisEventPageList()
    },
    methods: {
        handleSearch() {
            this.setParams(this._.cloneDeep(this.param))
            let page = {page: 1, pageSize: this.page.pageSize}
            this.$store.commit('SET_PAGE', page)
            this.$emit('toggleTab')
        },
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true
                this.param.title = query
                this._getDisEventPageList()
            } else {
                this.activityList = []
            }
        },
        _getDisEventPageList() {
            getSimpleDisEventPageList({
                data: Object.assign({}, {title: this.param.title}, this.selectPage),
                success: data => {
                    this.activityList = data.data.content
                    this.selectPage.pageCount = data.data.pageinfo.pageCount
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-scrollbar__wrap').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.selectPage.page < _this.selectPage.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getSimpleDisEventPageList()
                                }
                            }
                        })
                    })
                    if (this.activityList.length) {
                        this.param.eventinnerid = this.param.eventinnerid ? this.param.eventinnerid : this.activityList[0].innerid
                        // this.param.eventinnerid = 'fYGKpIgBvNceOD8s'
                        this.$emit('toggleTab')
                    }
                    this.loading = false
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.loading = false
                }
            })
        },
        _getSimpleDisEventPageList() {
            this.selectPage.page++
            getSimpleDisEventPageList({
                data: Object.assign({}, {title: this.param.title}, this.selectPage),
                success: data => {
                    this.activityList = this.activityList.concat(data.data.content)
                    this.selectPage.pageCount = data.data.pageinfo.pageCount
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-scrollbar__wrap').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.selectPage.page < _this.selectPage.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getSimpleDisEventPageList()
                                }
                            }
                        })
                    })
                    this.loading = false
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.loading = false
                }
            })
        },
        ...mapActions(['setLoading', 'setParams'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['page'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.npHeader {
    .title{
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        .classes{
            margin-bottom: 0;
        }
        .el-input__icon{
            line-height: 1;
        }
    }
    .el-select{
        input{
            width: 320px;
        }
    }
    .el-input__suffix-inner{
        .el-select__caret:before{
            content: "\E6E1";
        }
    }
}
</style>
